(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ShopperAdoptionCtrl', ShopperAdoptionCtrl);

  // @ngInject
  function ShopperAdoptionCtrl(storeKeys, filters, DateUtil, ConsumerChart, ShopperReports, StandardReports, Callout,
                               ShopperAdoption, ShopperAdoptionCallout, SectionConfig, UserCohort) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();

    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.shopperAdoptionCharts = [
            SectionConfig.adoption,
            SectionConfig.tfReg,
            SectionConfig.tfSessionsAdoption,
            SectionConfig.tfOrdersAdoption,
            SectionConfig.tfRevenue
    ].map(function (section) {
      return {
        sectionConfig: Callout.labelValueConfig(section),
        formatDataFn: function (rawData) {
          vm[section.name] = StandardReports.findInSummary(rawData.summary, 'TFPercent', UserCohort.tf.value);
          return rawData;
        }
      }
    });

    vm.adoptionCallouts = [
        ShopperAdoptionCallout(
            'TFAdoptionCallout.tmpl.html',
            SectionConfig.adoption.chart.label,
            SectionConfig.adoption.name
        ),
        ShopperAdoptionCallout(
            'TFSessionsCallout.tmpl.html',
            SectionConfig.tfSessionsAdoption.chart.label,
            SectionConfig.tfSessionsAdoption.name
        ),
        ShopperAdoptionCallout(
            'TFRevenueCallout.tmpl.html',
            SectionConfig.tfRevenue.chart.label,
            SectionConfig.tfRevenue.name
        )
    ];

  }
  })();
